module.exports = __webpack_public_path__ + "img/agriculture_1.73b35a53.jpg";